import semanticClassNames from '../PopupContainer/PopupContainer.semanticClassNames';

export default semanticClassNames;
